import React from 'react'
import {
	MaximizeIcon,
	MinimizeIcon,
	RefreshCwIcon,
	SparklesIcon,
	XIcon,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { useFullScreen } from '@/shared/hooks/useFullScreen'
import { ampli } from '@/shared/lib/ampli'

import { useAssistantConversation } from '../lib/useAssistantConversation'
import ChatAgentSwitcher from './ChatAgentSwitcher'

export default function ChatHeader({
	refs,
	handleClose,
}: {
	refs: { containerRef: React.RefObject<null | HTMLDivElement> }
	handleClose: () => void
}) {
	const { t } = useTranslation()

	const { resetConversation } = useAssistantConversation()
	const [isFullScreen, toggleFullScreen] = useFullScreen({
		ref: refs.containerRef,
	})

	return (
		<div className='flex items-center justify-between rounded-t-lg p-4'>
			<div className='flex items-center gap-2'>
				<SparklesIcon className='size-4 text-primary' />
				<ChatAgentSwitcher />
			</div>
			<div>
				<Button variant='ghost' size='icon' onClick={() => toggleFullScreen()}>
					{!isFullScreen ? <MaximizeIcon /> : <MinimizeIcon />}
				</Button>
				<Tooltip>
					<TooltipTrigger asChild>
						<Button
							data-testid='chat-reset'
							variant='ghost'
							size='icon'
							onClick={() => {
								ampli.aiChatResetConversation()
								resetConversation()
							}}
						>
							<RefreshCwIcon />
						</Button>
					</TooltipTrigger>
					<TooltipContent>
						{t('assistant.reset_chat', { defaultValue: 'Reset chat' })}
					</TooltipContent>
				</Tooltip>
				<Tooltip>
					<TooltipTrigger asChild>
						<Button
							onClick={() => handleClose()}
							data-testid='chat-close'
							variant='ghost'
							size='icon'
						>
							<XIcon />
						</Button>
					</TooltipTrigger>
					<TooltipContent>
						{t('assistant.close_chat', { defaultValue: 'Close chat' })}
					</TooltipContent>
				</Tooltip>
			</div>
		</div>
	)
}
